import React from 'react';
import { Dimensions } from 'react-native';
import { Surface } from 'react-native-paper';
import SafeAreaView from 'react-native-safe-area-view';
import styled from 'styled-components/native';

import Image from '@src/components/Image';
import VideoBase from '@src/components/Video';
import { padding } from '@src/configuration/constants';

type ContainerProps = {
  color?: string;
  children: React.ReactNode;
};

export const Container = styled(SafeAreaView)<ContainerProps>`
  background-color: ${({ color }) => color ?? '#4a4a4a'};
  flex: 1;
`;

export const Header = styled.View`
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 5px;
  align-items: center;
`;

export const Card = styled(Surface)`
  flex: 1;
  margin: ${padding}px;
  border-radius: ${({ theme }) => theme.roundness}px;
  align-items: center;
  justify-content: center;
  padding: ${padding / 2}px;
  elevation: 5;
`;

export const Photo = styled(Image)`
  flex: 1;
  width: 100%;
  max-height: 80%;
  border-radius: ${({ theme }) => theme.roundness}px;
  background-color: ${({ theme }) => theme.colors.placeholder};
  margin-bottom: ${padding}px;
`;

export const Video = styled(VideoBase).attrs({
  resizeMode: 'cover',
})`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.placeholder};
  aspect-ratio: ${Dimensions.get('window').width /
  Dimensions.get('window').height};
`;

export const VideoWrapper = styled.View`
  border-radius: ${({ theme }) => theme.roundness}px;
  margin-bottom: ${padding}px;
  overflow: hidden;
  width: 100%;
  max-height: 80%;
`;
